import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import BlankContent from '../common/BlankContent';

import SessionTableRow from './SessionTableRow';
import SessionListItem from './SessionListItem';
import './SessionsTable.scss';
import CustomPagination from "../common/CustomPagination";
import BetaFeature from '../common/BetaFeature';

const SessionTable = props => {
  const isEmpty = !props.sessions || !props.sessions.length;
  return (
    <>
      <Paper sx={{ width: '100%', display: {xs: 'none', sm: 'block'}}} elevation={0}>
        <TableContainer>
          <Table className='session-table'>
            <TableHead>
              <TableRow sx={{'th': {paddingBottom: '6px'}}}>
                {/* <TableCell align="left"></TableCell> */}
                <TableCell align="left">Status</TableCell>
                {
                  props.showAllProviders
                  && <TableCell align='left'>Provider</TableCell>
                }
                <TableCell align="left">Date/Time</TableCell>
                {
                  props.isPatient
                  ? <TableCell align="left">Provider</TableCell>
                  : <TableCell align="left">Name</TableCell>
                }
                <BetaFeature hideTag={true}>
                  <TableCell align='left'>Case</TableCell>
                </BetaFeature>
                <TableCell align="left">Type</TableCell>
                {
                  props.isPatient
                  ? null
                  : <TableCell align="left">Contact #</TableCell>
                }
                <TableCell align="left">Location</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.rows|| []).map(row =>
                <SessionTableRow
                  {...row}
                  showAllProviders={props.showAllProviders}
                  isPatient={props.isPatient}
                  afterSave={() => {
                    console.log('SessionTableRow.afterSave');
                    props.afterSave();
                  }}
                />
              )}
            </TableBody>
          </Table>
          {
            isEmpty
            ? <BlankContent
              title='No sessions found'
              Icon={QuestionMarkIcon}
            />
            : null
          }
        </TableContainer>
        {
          !isEmpty &&
          <Box sx={{marginTop: '0.625rem'}}>
            <CustomPagination
              pageSize={props.pageSize}
              pageIndex={props.pageIndex}
              count={props.count}
              onPageChange={(e,num) => props.onPageChange(e, num)}
            ></CustomPagination>
          </Box>
        }

      </Paper>
      {/* If screen size is xs then replace the table with a mobile-friendly list */}
      <Box sx={{display: {'xs': 'block', 'sm': 'none', 'md': 'none', 'lg': 'none'}}}>
        <Stack spacing={1} padding={1}>
          {(props.rows|| []).map(row =>
            <SessionListItem
              session={row.data}
              buttons={row.buttons}
              isPatient={props.isPatient}
              onSave={props.afterSave}
              isMobile={props.isMobile}
              showAllProviders={props.showAllProviders}
            />
          )}
        </Stack>
        <Box style={{marginTop: '1em'}}>
          { props.rows && props.rows.length
            ? <Stack direction='row' justifyContent='center'>
                <CustomPagination
                    pageSize={props.pageSize}
                    pageIndex={props.pageIndex}
                    count={props.count}
                    onPageChange={props.onPageChange}
                ></CustomPagination>
            </Stack>
            : null
          }
        </Box>
        {
          isEmpty
          ? <BlankContent
            title='No sessions found'
            Icon={QuestionMarkIcon}
          />
          : null
        }
      </Box>
    </>
  );
};

SessionTable.defaultProps = {
  showAllProviders: false,
};

SessionTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object, // data for the row
    buttons: PropTypes.arrayOf(PropTypes.element),
  })),
  showAllProviders: PropTypes.bool,
  count: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  afterSave: PropTypes.func,
};

export default SessionTable;
